<template>
	<div>
        <div class="modal fade" id="mdgerarparcelas" role="dialog">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 v-if="parseInt(vproptipo) === 0" class="modal-title" id="exampleModalLabel">Gerar parcelas à receber</h5>
                        <h5 v-else class="modal-title" id="exampleModalLabel">Gerar parcelas à pagar</h5>                        
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div v-show="parseInt(vproptipo) === 0" class="col-sm-12 col-md-6 col-lg-6">
                                <span class="lblselect2">*Cliente:</span>
                                <select id="cbclientegp" data-placeholder="Selecione um cliente" data-allow-clear="true"
                                        style="width:100%;" v-model="idclientegp">
                                </select>
                            </div>                            
                            <div v-show="parseInt(vproptipo) === 1" class="col-sm-12 col-md-6 col-lg-6">
                                <span class="lblselect2">Fornecedor:</span>
                                <select id="cbfornecedorgp" data-placeholder="Selecione um fornecedor" data-allow-clear="true"
                                        style="width:100%;" v-model="idfornecedorgp">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edidentificadorgp">*Identificador:</label>
                                <input type="text" class="form-control form-control-sm" id="edidentificadorgp" v-model="identificadorgp"
                                    maxlength="25" style="text-transform: uppercase;"
                                    data-bv-group=".group">
                            </div>  
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">*Filial:</span>
                                <select id="cbfilialgp" v-model="idfilialgp"
                                        data-placeholder="Selecione a filial" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div> 
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtemissaogp">*Emissão:</label>
								<div class="input-group">
									<date-picker id="eddtemissaogp" v-model="dtemissaogp" :config="options"
										class="form-control form-control-sm"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>                            
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtvenc1a">*Vencto 1a:</label>
								<div class="input-group">
									<date-picker id="eddtvenc1a" v-model="dtvenc1agp" :config="options"
										class="form-control form-control-sm"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edparcelasgp">*Parcelas:</label>
                                <input type="number" class="form-control form-control-sm" id="edparcelasgp" v-model="parcelasgp"
                                    min="1" max="99" data-bv-group=".group">
                            </div> 
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edintervalogp">*Intervalo:</label>
                                <input type="number" class="form-control form-control-sm" id="edintervalogp" v-model="intervalogp"
                                    min="1" max="99" data-bv-group=".group">
                            </div>                            
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">*Tipo de cobrança:</span>
                                <select id="cbtipocobrancagp" v-model="idtipocobrancagp"
                                        data-placeholder="Selecione o tipo de cobrança" data-allow-clear="true"
                                        style="width:100%;">
                                </select>
                            </div>                                                                                                                                                  
                            <div v-show="parseInt(vproptipo) === 0" class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">*Vendedor:</span>
                                <select id="cbvendedorgp" data-placeholder="Selecione um vendedor" data-allow-clear="true"
                                    v-model="idvendedorgp" style="width:100%;">
                                </select>
                            </div>                            
                            <div v-show="parseInt(vproptipo) === 0" class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">*Cobrador:</span>
                                <select id="cbcobradorgp" data-placeholder="Selecione um cobrador" data-allow-clear="true"
                                    v-model="idcobradorgp" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbtpjurosgp">Tipo de juros:</label>
                                <select class="form-control form-control-sm" v-model="tpcalcjurosgp" id="cbtpjurosgp">
                                    <option value="0" selected="true">Percentual (%)</option>
                                    <option value="1">Valor (R$)</option>
                                </select>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2">
                                <label for="edfatjurosgp">Fator (%):</label>
                                <money class="form-control form-control-sm" id="edfatjurosgp" v-bind="money" v-model="fatjurosgp"
                                    value="0,00" maxlength="20" data-bv-group=".group"
                                    style="text-align:right;"></money>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbtpmultagp">Tipo de multa:</label>
                                <select class="form-control form-control-sm" v-model="tpcalcmultagp" id="cbtpmultagp">
                                    <option value="0" selected="true">Percentual (%)</option>
                                    <option value="1">Valor (R$)</option>
                                </select>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2">
                                <label for="edfatmultagp">Fator (%):</label>
                                <money class="form-control form-control-sm" id="edfatmultagp" v-bind="money" v-model="fatmultagp"
                                    value="0,00" maxlength="20" data-bv-group=".group"
                                    style="text-align:right;"></money>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2">
                                <label for="edvalortotalgp">*Valor total:</label>
                                <money class="form-control form-control-sm" id="edvalortotalgp" v-bind="money" v-model="valortotalgp"
                                    value="0,00" maxlength="20" data-bv-group=".group"
                                    style="text-align:right; background: #0acf97; color: white; font-weight: bold;"></money>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2">
                                <button type="button" @click.prevent="mtdgerar()"
                                        class="btn btn-primary btn-sm" style="width:100%; margin-top:20px;"><i class="fa fa-gear"></i> Gerar parcelas
                                </button>                                
                            </div>                            
                        </div>
                        <div v-show="lsttitulosgp.length > 0" class="row">
                            <div class="col-lg-12">
                                <div class="table-responsive">
                                    <table class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                        <thead class="thead-light">
                                        <tr>
                                            <th width="35px" style="text-align: center;"></th>
                                            <th width="80">Nr. título:</th>
                                            <th width="80">Vencimento:</th>
                                            <th width="100">Tipo de cobrança:</th>
                                            <th width="80">Valor:</th>															
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(titulo, index) in lsttitulosgp" v-bind:key="index">
                                                <td width="35px" class="center" style="text-align: center;">
                                                    <a class="btn btn-primary btn-sm btn-opcrud ajt-btn" href="#"                                                    
                                                    @click.prevent="mtdalterartitulo(titulo)"><i class="fa fa-edit"></i></a>
                                                </td>												
                                                <td width="80px">{{ titulo.codtit }}</td>
                                                <td width="80px">{{ titulo.dtventit }}</td>
                                                <td width="100px">{{ titulo.descricaocob }}</td>
                                                <td width="80px" style="text-align: right;">
                                                    <strong>{{ mtdformatavalordecimal(titulo.vltit, 2) }}</strong>
                                                </td>                                                       												
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>										                                                             
                            </div>    
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" style="width: 150px;" @click.prevent="mtdsalvarparcelas()"><i class="fa fa-save"></i> Salvar parcelas</button>                                                
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Cancelar</button>                        
                    </div>
                </div>
            </div>
        </div>

		<!-- Modal para alteração da parcela -->
		<div class="modal fade" id="mdalterartitulogp">
			<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title"><i class="fa fa-edit"></i> Alteração do título</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>				 
				<div class="modal-body">
					<div class="row">
						<div class="col-md-4">
							<label>Nr. título:</label>
							<input type="text" class="form-control form-control-sm" v-model="tacodtitgp" disabled style="font-weight: bold;">
						</div>
						<div class="col-sm-12 col-md-4 col-lg-4">
							<label for="eddtventitgp">Dt. Vencimento:</label>
							<div class="input-group">
								<date-picker id="eddtventitgp" v-model="tadtventitgp" :config="options" class="form-control form-control-sm"></date-picker>
								<div class="input-group-append">
									<span class="input-group-text"><i class="fa fa-calendar"></i></span>
								</div>										
							</div>
						</div>
						<div class="col-sm-12 col-md-4 col-lg-4">
							<label for="edvltitgp">Valor:</label>
							<money type="text" class="form-control form-control-sm" id="edvltitgp" v-model="tavltitgp" v-bind="money" data-bv-group=".group" style="text-align:right;"></money>
						</div>
						<div  class="col-sm-12 col-md-12 col-lg-12">
							<span class="lblselect2">Tipo de cobrança:</span>
							<select id="cbtipocobrancaaltgp" data-placeholder="Selecione um tipo de cobrança" v-model="taidtipocobrancagp" data-allow-clear="true" style="width:100%;">
							</select>
						</div>
						<div v-show="parseInt(tatipocobrancagp) === 1" class="col-sm-12 col-md-12 col-lg-12" style="padding-top: 15px;">
							<div class="card">
								<div class="card-header card-in text-center" style="padding: 5px;">DADOS DO CHEQUE</div>
								<div class="card-body" style="padding: 10px;">
									<div class="row">
										<div class="col-md-4">
											<label>Nr. Cheque:</label>
											<input type="text" id="ednumerochequegp" class="form-control form-control-sm" v-model="tanumerochequegp">
										</div>
										<div  class="col-sm-12 col-md-8 col-lg-8">
											<span class="lblselect2">Banco:</span>
											<select id="cbbancogp" data-placeholder="Selecione um banco" v-model="taidbancogp" data-allow-clear="true" style="width:100%;">
											</select>
										</div>
										<div class="col-md-4">
											<label>Agência:</label>
											<input type="text" id="edagenciagp" class="form-control form-control-sm" v-model="taagenciagp">
										</div>
										<div class="col-md-4">
											<label>Conta:</label>
											<input type="text" id="edcontagp" class="form-control form-control-sm" v-model="tacontagp">
										</div>
										<div class="col-md-4">
											<label>Praça:</label>
											<input type="text" id="edpracagp" class="form-control form-control-sm" v-model="tapracagp">
										</div>
										<div class="col-md-12">
											<label>Emitente:</label>
											<input type="text" id="edemitentegp" class="form-control form-control-sm" v-model="taemitentegp">
										</div>
										<div class="col-md-5">
											<label for="edcnpjcpfgp">CNPJ/CPF:</label>
											<input type="text" v-model="tacnpjcpfgp"
												class="form-control form-control-sm" id="edcnpjcpfgp" 
												v-mask="['###.###.###-##', '##.###.###/####-##']">
										</div>
										<div  class="col-md-7">
											<span class="lblselect2">Situação do cheque:</span>
											<select id="cbsituacaochequegp" data-placeholder="Selecione uma situação" v-model="taidsituacaochequegp" data-allow-clear="true" style="width:100%;">
											</select>
										</div>																																																	
									</div>
								</div>
							</div>
						</div>																														
					</div>
				</div>        
				<div class="modal-footer" style="padding: 5px;">
					<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtconfirmaralteracaotitulo()"><i class="fa fa-check"></i> Confirmar</button>
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
				</div>        
			</div>
			</div>
		</div>                
    </div>
</template>
<script>
	import util from '../utilitarios/util.js'
	export default {
        name : "cmpgerarparcelas",
        props: [
            'vproptipo'
        ],       			
		data : function () {
			return {
                lsttitulosgp            : [],
                utodasfiliais 		    : this.$store.state.usuario.todasfiliais,
                idclientegp             : null,
                idfornecedorgp          : null,
                identificadorgp         : '',
                idfilialgp              : null,
                dtemissaogp             : util.DataAtual(true),
                dtvenc1agp              : util.DataAtual(true),
                parcelasgp              : 1,
                intervalogp             : 30,
                idtipocobrancagp        : null,
                tipocobgp               : 0,//variável para determinar se é cheque ou não
                idvendedorgp            : null,
                idcobradorgp            : null,
                tpcalcjurosgp           : 0,
                fatjurosgp              : 0,
                tpcalcmultagp           : 0,
                fatmultagp              : 0,
                valortotalgp            : 0,                

				//variáveis da alteração do título
				tacodtitgp 			    : '',
				tadtventitgp			: '',
				tavltitgp				: 0,
				taidtipocobrancagp	    : null,
				tatipocobrancagp		: 0,// 0 - Normal 1 - Cheque
				tadescricaocobgp		: '',
				tanumerochequegp		: '',
				taidbancogp			    : null,
				tadescbancogp			: '',
				taagenciagp			    : '',
				tacontagp				: '',
				tapracagp				: '',
				taemitentegp			: '',
				tacnpjcpfgp			    : '',						
				taidsituacaochequegp	: null,
				tadescsituacaochequegp  : '',

                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                },
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '',     //aqui colocar o cifrão se for necessário
                    precision: 2,
                    masked: false
                }                
            }
         },
		methods: {
			formatavalor(valor, digitos){
				return util.formatavalordecimais(valor, digitos);
            },
            arredondavalores(val, casas) {
                return util.arredondaValores( val, casas, 'round' );
            },
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},
			mtdformatavalordecimal(valor, digitos){
				return util.formatavalordecimais(valor, digitos);
			},
			mtdformatadatagravar(dtformatar){
				let strret = dtformatar.replace(/\D/g, "");
				return strret.substring(0,2)+'/'+strret.substring(2,4)+'/'+strret.substring(4);
			},                        
            mtdiniciar_def_cmp_gp(){
                let vself         = this;
				let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
                let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';                                

				$("#cbclientegp").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbclientes',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 1,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.idclientegp = $("#cbclientegp").val();
				});

				$("#cbfornecedorgp").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbfornecedores',
								c1: 'id',
								c2: 'nomerazaosocial'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 1,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.idfornecedorgp = $("#cbfornecedorgp").val();
				});                

				$("#cbtipocobrancagp").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbtiposcobranca',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.idtipocobrancagp = $("#cbtipocobrancagp").val();
                    if (vself.idtipocobrancagp !== null){
                        let loader      = vself.$loading.show();				
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and id='+vself.idtipocobrancagp},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtiposcobranca.php');
                        retorno.then(function (response) {
                            loader.hide();
                            vself.tipocobgp = response.data[0].tipo;
                        }).catch(function (response) {
                            vself.tipocobgp = 0;
                            loader.hide();
                        });
                    }else{
                        vself.tipocob = 0;
                    }
                });                

				$("#cbvendedorgp").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbvendedores',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.idvendedorgp = $("#cbvendedorgp").val();
                });

				$("#cbcobradorgp").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbcobradores',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.idcobradorgp = $("#cbcobradorgp").val();
                });                

                $("#cbfilialgp").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.idfilialgp = $("#cbfilialgp").val();
                });

				$("#cbtipocobrancaaltgp").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbtiposcobranca',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.taidtipocobrancagp = $("#cbtipocobrancaaltgp").val();
                    if (vself.taidtipocobrancagp != null) {
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and id='+vself.taidtipocobrancagp},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtiposcobranca.php');
                        retorno.then(function (response) {
                            vself.tatipocobrancagp = parseFloat(response.data[0].tipo); 
                            loader.hide();
                        }).catch(function (response) {
                            loader.hide();
                        });
                    } else {//quando limpa seleção
                        vself.tatipocobrancagp = 0;
                    }					
				});

				$("#cbbancogp").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbbancos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.taidbancogp = $("#cbbancogp").val();
				});

				$("#cbsituacaochequegp").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbsituacoescheques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.taidsituacaochequegp = $("#cbsituacaochequegp").val();
				});                
            },
            mtdgerar(){
                let vself = this;
                if (parseInt(vself.vproptipo) === 0){//opções do contas à receber
                    if (vself.idclientegp === null){
                        vself.$toastr.w('Cliente deve ser informado!', 'Atenção!');
                        $('#cbclientegp').select2('open');
                        return;
                    }
                    if (vself.idvendedorgp === null){
                        vself.$toastr.w('Vendedor deve ser informado!', 'Atenção!');
                        $('#cbvendedorgp').select2('open');
                        return;
                    }             
                    if (vself.idcobradorgp === null){
                        vself.$toastr.w('Cobrador deve ser informado!', 'Atenção!');
                        $('#cbcobradorgp').select2('open');
                        return;
                    }
                }else{//opções do contas à pagar
                    if (vself.idfornecedorgp === null){
                        vself.$toastr.w('Fornecedor deve ser informado!', 'Atenção!');
                        $('#cbfornecedorgp').select2('open');
                        return;
                    }
                }
                if (vself.identificadorgp === ''){
                    vself.$toastr.w('Identificador das parcelas deve ser informado!', 'Atenção!');
                    $('#edidentificadorgp').focus();
                    return;
                }
                if (parseInt(vself.parcelasgp) <= 0){
                    vself.$toastr.w('Quantidade de parcelas inválida!', 'Atenção!');
                    $('#edparcelasgp').focus();
                    return;
                }
                if (parseInt(vself.intervalogp) <= 0){
                    vself.$toastr.w('Intervalo entre parcelas inválido!', 'Atenção!');
                    $('#edintervalogp').focus();
                    return;
                }
                if (vself.idtipocobrancagp === null){
                    vself.$toastr.w('Tipo de cobrança deve ser informado!', 'Atenção!');
                    $('#cbtipocobrancagp').select2('open');
                    return;
                }                                 
                if (parseFloat(vself.valortotalgp) <= 0){
                    vself.$toastr.w('Valor total deve ser maior que 0 (Zero)!', 'Atenção!');
                    $('#edvalortotalgp').focus();
                    return;
                }                
                if (vself.idfilialgp === null){
                    vself.$toastr.w('Filial deve ser informada!', 'Atenção!');
                    $('#cbfilialgp').select2('open');
                    return;
                }                
                vself.lsttitulosgp = [];
                for (let i = 0; i < vself.parcelasgp; i++) {
                    let dtventmp = i + 1  === 1 ? vself.dtvenc1agp : util.somaDias(vself.mtdformatadatagravar(vself.dtvenc1agp), parseFloat(i * vself.intervalogp));
                    let parctmp = {
                        'idclifor'            : parseInt(vself.vproptipo) === 0 ? this.idclientegp : this.idfornecedorgp,  
                        'codtit'              : this.identificadorgp + '/' + (i+1) +'-'+this.parcelasgp,
                        'idtipocobranca'      : this.idtipocobrancagp,
                        'descricaocob'        : $('#cbtipocobrancagp').select2('data')[0]['text'],  
                        'tipocobranca'        : this.tipocobgp,  
                        'dtemitit'            : this.dtemissaogp,
                        'dtventit'            : dtventmp,
                        'vltit'               : util.arredondaValores(parseFloat(this.valortotalgp) / parseFloat(this.parcelasgp), 2, 'round'),
                        'vlresta'             : util.arredondaValores(parseFloat(this.valortotalgp) / parseFloat(this.parcelasgp), 2, 'round'),
                        'tpcalcjuros'         : this.tpcalcjurosgp,
                        'tpcalcmulta'         : this.tpcalcmultagp,
                        'fatjuros'            : this.fatjurosgp,
                        'fatmulta'            : this.fatmultagp,
                        'obstit'              : '',
                        'obstitsis'           : '',
                        'numerocheque'        : '',
                        'idbanco'             : null,
                        'agencia'             : '',
                        'conta'               : '',
                        'praca'               : '',
                        'cnpjcpf'             : '',
                        'emitente'            : '',
                        'idsituacaocheque'    : null,
                        'idfilial'            : this.idfilialgp,
                        'idpedido'            : '',
                        'idvendedor'          : parseInt(vself.vproptipo) === 0 ? this.idvendedorgp : null,
                        'vlpagtit'            : 0,
                        'nossonumero'         : '',
                        'idbancoboleto'       : '',
                        'idcobrador'          : parseInt(vself.vproptipo) === 0 ? this.idcobradorgp : null,
                        'ultimojuros'         : 0,
                        'dtultpagtit'         : '',
                        'inativo'             : 0
                    };
                    vself.lsttitulosgp.push(parctmp);
                }          
            },
			mtdalterartitulo(titulo){
				// if (!util.opcaousuario('020Z.010Z.110Z', this.$store.state.perfilusuario)){
				// 	this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				// 	return;
				// }

				this.tacodtitgp 				= titulo.codtit;
				this.tadtventitgp				= titulo.dtventit;
				this.tavltitgp				    = titulo.vltit;
				this.taidtipocobrancagp		    = titulo.idtipocobranca;
				this.tatipocobrancagp			= titulo.tipocobranca;
				this.tadescricaocobgp			= titulo.descricaocob;
				this.tanumerochequegp			= titulo.numerocheque;
				this.taidbancogp				= titulo.idbanco;
				this.tadescbancogp			    = titulo.descbanco;
				this.taagenciagp				= titulo.agencia;
				this.tacontagp				    = titulo.conta;
				this.tapracagp				    = titulo.praca;
				this.taemitentegp				= titulo.emitente;
				this.tacnpjcpfgp				= titulo.cnpjcpf;						
				this.taidsituacaochequegp		= titulo.idsituacaocheque;
				this.tadescsituacaochequegp	= titulo.descsituacaocheque;				


				var deftipocobranca  = new Option(this.tadescricaocobgp, this.taidtipocobrancagp, true, true);
				$('#cbtipocobrancaaltgp').append(deftipocobranca).trigger('change');

				if (this.taidbancogp !== null){
					var defbanco  = new Option(this.tadescbancogp, this.taidbancogp, true, true);
					$('#cbbancogp').append(defbanco).trigger('change');
				}else{
					$("#cbbancogp").val(null).trigger('change');
				}
				
				if (this.taidsituacaochequegp !== null){
					var defsituacaoch  = new Option(this.tadescsituacaochequegp, this.taidsituacaochequegp, true, true);
					$('#cbsituacaochequegp').append(defsituacaoch).trigger('change');
				}else{
					$("#cbsituacaochequegp").val(null).trigger('change');
				}

				$('#mdalterartitulogp').modal('show');
			},
			mtconfirmaralteracaotitulo(){
				if (this.tadtventitgp === ''){
					this.$toastr.w('Data de vencimento deve ser informada!', 'Atenção!');
					$('#eddtventit').focus();
					return;
				}
				if (parseFloat(this.tavltitgp) <= 0){
					this.$toastr.w('Valor do título inválido!', 'Atenção!');
					$('#edvltit').focus();
					return;
				}
				if (this.taidtipocobrancagp === null){
					this.$toastr.w('Tipo de cobrança deve ser informada!', 'Atenção!');
					$('#cbtipocobrancaaltgp').focus();
					return;
				}				
				if (parseInt(this.tatipocobrancagp) === 1){
					if (this.tanumerochequegp === ''){
						this.$toastr.w('Número do cheque deve ser informado!', 'Atenção!');
						$('#ednumerochequegp').focus();
						return;
					}
					if (this.taidbancogp === null){
						this.$toastr.w('Banco deve ser informado!', 'Atenção!');
						$('#cbbancogp').focus();
						return;
					}
					if (this.taagenciagp === ''){
						this.$toastr.w('Agência deve ser informada!', 'Atenção!');
						$('#edagenciagp').focus();
						return;
					}
					if (this.tacontagp === ''){
						this.$toastr.w('Conta deve ser informada!', 'Atenção!');
						$('#edcontagp').focus();
						return;
					}
					if (this.tapracagp === ''){
						this.$toastr.w('Praça deve ser informada!', 'Atenção!');
						$('#edpracagp').focus();
						return;
					}
					if (this.taemitentegp === ''){
						this.$toastr.w('Emitente deve ser informado!', 'Atenção!');
						$('#edemitentegp').focus();
						return;
					}
					if (this.tacnpjcpfgp === ''){
						this.$toastr.w('CNPJ/CPF deve ser informado!', 'Atenção!');
						$('#edcnpjcpfgp').focus();
						return;
					}
					if (this.taidsituacaochequegp === null){
						this.$toastr.w('Situação do cheque deve ser informada!', 'Atenção!');
						$('#cbsituacaochequegp').focus();
						return;
					}					
				}
				let indice = util.getArrayIndexForKey(this.lsttitulosgp, 'codtit', this.tacodtitgp);
				//this.vtotaltitulosgp = this.vtotaltitulosgp - this.lsttitulosgp[indice].vltit;


				this.lsttitulosgp[indice].dtventit 			    = this.tadtventitgp;
				this.lsttitulosgp[indice].dtventit				= this.tadtventitgp;
				this.lsttitulosgp[indice].vltit				    = this.tavltitgp;
				this.lsttitulosgp[indice].idtipocobranca		= this.taidtipocobrancagp;
				this.lsttitulosgp[indice].tipocobranca			= this.tatipocobrancagp;
				this.lsttitulosgp[indice].descricaocob			= $('#cbtipocobrancaaltgp').select2('data')[0]['text'];

				this.lsttitulosgp[indice].numerocheque			= parseInt(this.tatipocobrancagp) === 1 ? this.tanumerochequegp 	: '';
				this.lsttitulosgp[indice].idbanco				= parseInt(this.tatipocobrancagp) === 1 ? this.taidbancogp 			: null;
				this.lsttitulosgp[indice].descbanco			    = parseInt(this.tatipocobrancagp) === 1 ? $('#cbbancogp').select2('data')[0]['text'] : '';
				this.lsttitulosgp[indice].agencia				= parseInt(this.tatipocobrancagp) === 1 ? this.taagenciagp 			: '';
				this.lsttitulosgp[indice].conta				    = parseInt(this.tatipocobrancagp) === 1 ? this.tacontagp 			: '';
				this.lsttitulosgp[indice].praca				    = parseInt(this.tatipocobrancagp) === 1 ? this.tapracagp 			: '';
				this.lsttitulosgp[indice].emitente				= parseInt(this.tatipocobrancagp) === 1 ? this.taemitentegp 		: '';
				this.lsttitulosgp[indice].cnpjcpf				= parseInt(this.tatipocobrancagp) === 1 ? this.tacnpjcpfgp 			: '';						
				this.lsttitulosgp[indice].idsituacaocheque		= parseInt(this.tatipocobrancagp) === 1 ? this.taidsituacaochequegp : null;
				this.lsttitulosgp[indice].descsituacaocheque	= parseInt(this.tatipocobrancagp) === 1 ? $('#cbsituacaochequegp').select2('data')[0]['text'] : '';				


				//this.vtotaltitulosgp = this.vtotaltitulosgp + this.tavltitgp;

				$('#mdalterartitulogp').modal('hide');
			},
			mtdpendenciasparcela(){
				let ret = false;
				for (let titulo of this.lsttitulosgp) {
					if (parseInt(titulo.tipocobranca) === 1){
						if (titulo.numerocheque === ''){
							ret = true;
							break;
						}
						if (titulo.idbanco === null){
							ret = true;
							break;
						}
						if (titulo.agencia === ''){
							ret = true;
							break;
						}
						if (titulo.conta === ''){
							ret = true;
							break;
						}
						if (titulo.praca === ''){
							ret = true;
							break;
						}
						if (titulo.emitente === ''){
							ret = true;
							break;
						}
						if (titulo.cnpjcpf === ''){
							ret = true;
							break;
						}
						if (titulo.idsituacaocheque === null){
							ret = true;
							break;
						}																		
					}
				}
				return ret;
			},
            mtdsalvarparcelas(){
                let vself = this;
                if (vself.lsttitulosgp.length === 0){
                    vself.$toastr.w('Não há parcelas à serem salvas!', 'Atenção!');
                    return;
                }
                if (vself.mtdpendenciasparcela()){
                    vself.$toastr.w('Existe(m) alguma(s) pendência(s) na(s) parcela(s) à sere(m) gerada(s)! Verifque e tente novamente.', 'Atenção!');
                    return;
                }                 
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma geração dos títulos?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdconfirmacaosalvar();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });                
            },
            mtdconfirmacaosalvar(){
                let vself  = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idclifor',     valor : parseInt(vself.vproptipo) === 0 ? vself.idclientegp : vself.idfornecedorgp},
                    {parametro: 'op',           valor : 'gerarparcelas'},
                    {parametro: 'titulos',      valor : JSON.stringify(vself.lsttitulosgp)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(vself.vproptipo) === 0 ? '030Z.010Z.100Z' : '030Z.040Z.090Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', parseInt(vself.vproptipo) === 0 ? vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceberv2.php' : vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulospagar.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Títulos gerados com sucesso!', 'Informação!');
                        $('#mdgerarparcelas').modal('hide');
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });                
            }                                    
        },
        mounted: function () { 
            let vself = this;
            $("#mdgerarparcelas").on('show.bs.modal', function () {
                //limpa variaveis
                vself.idfilialgp              = vself.$store.state.filialpadrao.codfil;
                var deffilial                 = new Option(vself.$store.state.filialpadrao.fantasia, vself.$store.state.filialpadrao.codfil, true, true);
                $('#cbfilialgp').append(deffilial).trigger('change');

                vself.lsttitulosgp            = [];
                vself.idclientegp             = null;
                vself.idfornecedorgp          = null;
                vself.identificadorgp         = '';                
                vself.dtemissaogp             = util.DataAtual(true);
                vself.dtvenc1agp              = util.DataAtual(true);
                vself.parcelasgp              = 1;
                vself.intervalogp             = 30;
                vself.idtipocobrancagp        = null;
                vself.tipocobgp               = 0;//variável para determinar se é cheque ou não
                vself.idvendedorgp            = null;
                vself.idcobradorgp            = null;
                vself.tpcalcjurosgp           = 0;
                vself.fatjurosgp              = 0;
                vself.tpcalcmultagp           = 0;
                vself.fatmultagp              = 0;
                vself.valortotalgp            = 0;
				$('#cbclientegp').val(null).trigger('change');
				$('#cbtipocobrancagp').val(null).trigger('change');
				$('#cbvendedorgp').val(null).trigger('change');
				$('#cbcobradorgp').val(null).trigger('change');
            });
            $("#mdgerarparcelas").on('shown.bs.modal', function () {
                if (parseInt(vself.vproptipo) === 0){
                    $("#cbclientegp").select2('open');
                }else{
                    $("#cbfornecedorgp").select2('open');
                }
            });
            vself.mtdiniciar_def_cmp_gp();     
        },
        computed: {
        },
        watch:{
        }
	}
</script>
<style>
</style>